import { sub } from 'date-fns';
//
import {
  _id,
  _ages,
  _roles,
  _prices,
  _emails,
  _ratings,
  _nativeS,
  _nativeM,
  _nativeL,
  _percents,
  _booleans,
  _sentences,
  _lastNames,
  _fullNames,
  _tourNames,
  _jobTitles,
  _taskNames,
  _postTitles,
  _firstNames,
  _fullAddress,
  _companyNames,
  _productNames,
  _descriptions,
  _phoneNumbers,
  _poemTitles,
  _poemTags,
  _poetNames,
  _poetStatusOptions,
  _poemContents,
} from './assets';

// ----------------------------------------------------------------------

export const _mock = {
  id: (index: number) => _id[index],
  time: (index: number) => sub(new Date(), { days: index, hours: index }),
  boolean: (index: number) => _booleans[index],
  role: (index: number) => _roles[index],
  // Text
  taskNames: (index: number) => _taskNames[index],
  postTitle: (index: number) => _postTitles[index],
  jobTitle: (index: number) => _jobTitles[index],
  tourName: (index: number) => _tourNames[index],
  productName: (index: number) => _productNames[index],
  sentence: (index: number) => _sentences[index],
  description: (index: number) => _descriptions[index],
  // Poem
  poemTitle: (index: number) => _poemTitles[index],
  poemTag: (index: number) => _poemTags[index],
  poemContent: (index: number) => _poemContents[index],
  poetName: (index: number) => _poetNames[index],
  poetStatusOption: (index: number) => _poetStatusOptions[index],
  // Contact
  email: (index: number) => _emails[index],
  phoneNumber: (index: number) => _phoneNumbers[index],
  fullAddress: (index: number) => _fullAddress[index],
  // Name
  firstName: (index: number) => _firstNames[index],
  lastName: (index: number) => _lastNames[index],
  fullName: (index: number) => _fullNames[index],
  companyName: (index: number) => _companyNames[index],
  // Number
  number: {
    percent: (index: number) => _percents[index],
    rating: (index: number) => _ratings[index],
    age: (index: number) => _ages[index],
    price: (index: number) => _prices[index],
    nativeS: (index: number) => _nativeS[index],
    nativeM: (index: number) => _nativeM[index],
    nativeL: (index: number) => _nativeL[index],
  },
  // Image
  image: {
    cover: (index: number) => `https://picsum.photos/seed/cover${index + 1}/800/400`,
    avatar: (index: number) => `/assets/poets/${(index+1)}.jpg`,
    travel: (index: number) => `https://picsum.photos/seed/travel${index + 1}/400/300`,
    company: (index: number) => `https://picsum.photos/seed/company${index + 1}/400/400`,
    product: (index: number) => `https://picsum.photos/seed/product${index + 1}/400/400`,
    portrait: (index: number) => `https://picsum.photos/seed/portrait${index + 1}/800/1000`,
  },
};
